import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from '../../services/cloud-functions-api.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NumeroalertasService {
  constructor(private api: CloudFunctionsApiService) {}

  getNumber() {
    return this.api.get('/metadata/contador_alertas').pipe(
      map((counter: any) => [
        {
          id: counter?.id || 'contador_alertas',
          data: () => counter,
        },
      ])
    );
  }

  editNumber() {
    return this.api.patch('/metadata/contador_alertas', {}).toPromise();
  }
}
